"use strict";
import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { DIALOG_AUX_FUNCTIONS } from "../util/classes";
import { Whisper } from "../util/classes";
import { UTL } from "../util/classes";


export class DIALOG1 {
    // --- משתני המערכת (היו ב-DIALOG1_components) ---
    public static overlay_element: HTMLDivElement = null; // אנחנו צריכים לפנות את אלמנט זה מבחוץ
    private static popup_element: HTMLDivElement = null;
    private static caption_element: HTMLDivElement = null;
    private static input_element: HTMLInputElement = null;
    private static select_false_element: HTMLDivElement = null;
    private static select_true_element: HTMLDivElement = null;
    private static close_button_element: HTMLSpanElement = null;
    private static defo_button_element: HTMLSpanElement = null;
    private static panel_element: HTMLDivElement = null;
    private static ok_button_element: HTMLButtonElement = null;
    private static cancel_button_element: HTMLButtonElement = null;
    private static erase_button_element: HTMLButtonElement = null;

    // --- משתני מצב ---
    private static MD_FLAG: boolean = false;
    private static defo_button_is_clicked: boolean = false;
    private static Vamod_MouseX: number = 0;
    private static Vamod_MouseY: number = 0;
    private static Vamod_ModalWindowLeftX: number = 0;
    private static Vamod_ModalWindowTopY: number = 0;

    private static par_callback_function: Function = null;
    private static par_input_OBJ: oInt16 | oInt32 | oInt64 = null;
    private static par_wisper: Whisper = null;

    public static readonly BID = {
        UNDEFINED: 0,
        OK: 1,
        CANCEL: 2,
        ERASE: 3
    };

    private static var_current_pseudo_focused_btn: number = DIALOG1.BID.OK;

    // --- פונקציות בסדר המקורי ---

    private static refresh_pseudo_focus_for_all_buttons(): void {
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG1.ok_button_element, DIALOG1.var_current_pseudo_focused_btn == DIALOG1.BID.OK);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG1.cancel_button_element, DIALOG1.var_current_pseudo_focused_btn == DIALOG1.BID.CANCEL);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG1.erase_button_element, DIALOG1.var_current_pseudo_focused_btn == DIALOG1.BID.ERASE);
    }

    private static respond_tab(): void {
        DIALOG1.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Forward(DIALOG1.var_current_pseudo_focused_btn, DIALOG1.BID.OK, DIALOG1.BID.ERASE);
        DIALOG1.refresh_pseudo_focus_for_all_buttons();
    }

    private static respond_shift_tab(): void {
        DIALOG1.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Backward(DIALOG1.var_current_pseudo_focused_btn, DIALOG1.BID.OK, DIALOG1.BID.ERASE);
        DIALOG1.refresh_pseudo_focus_for_all_buttons();
    }

    private static create_overlay_element(): HTMLDivElement {
        var overlay_element = document.createElement("div");
        overlay_element.style.position = "fixed";
        overlay_element.style.top = "0";
        overlay_element.style.left = "0";
        overlay_element.style.width = "100%";
        overlay_element.style.height = "100%";
        overlay_element.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
        overlay_element.style.zIndex = "1000";
        return overlay_element;
    }

    private static create_popup_element(): HTMLDivElement {
        var popup_element = document.createElement("div");
        popup_element.id = "id-DIALOG1-popup";
        popup_element.style.position = "absolute";
        popup_element.style.backgroundColor = "#fff";
        popup_element.style.padding = "0px";
        popup_element.style.borderRadius = "8px";
        popup_element.style.width = "320px";
        popup_element.style.textAlign = "center";
        return popup_element;
    }

    private static create_caption_element(): HTMLDivElement {
        var caption = document.createElement("div");
        caption.textContent = "DIALOG1";
        caption.style.fontSize = "24px";
        caption.style.fontWeight = "bold";
        caption.style.margin = "0px";
        caption.style.padding = "0px";
        caption.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_caption_backgroundColor();
        caption.style.color = DIALOG_AUX_FUNCTIONS.get_caption_forgroundColor();
        caption.style.borderTopLeftRadius = "5px";
        caption.style.borderTopRightRadius = "5px";
        caption.style.userSelect = "none";
        return caption;
    }

    private static create_close_button(): HTMLSpanElement {
        var element = DIALOG_AUX_FUNCTIONS.create_close_button_element();
        return element;
    }

    private static create_defo_button(): HTMLSpanElement {
        var element = DIALOG_AUX_FUNCTIONS.create_defo_button_element();
        return element;
    }

    private static create_case_element(): HTMLDivElement {
        var element = document.createElement("div");
        element.style.backgroundColor = "yellow";
        element.style.width = "100px";
        element.style.padding = "2px";
        element.style.margin = "auto";
        return element;
    }

    private static create_select_false_element(): HTMLDivElement {
        var element = document.createElement("div");
        element.style.backgroundColor = "green";
        element.style.fontSize = "26px";
        element.style.margin = "1px";
        element.textContent = "false";
        element.style.userSelect = "none";
        return element;
    }

    private static create_select_true_element(): HTMLDivElement {
        var element = document.createElement("div");
        element.style.backgroundColor = "green";
        element.style.fontSize = "26px";
        element.style.margin = "1px";
        element.textContent = "true";
        element.style.userSelect = "none";
        return element;
    }

    private static create_input_element(): HTMLInputElement {
        const element: HTMLInputElement = document.createElement("input");
        element.id = "id-DIALOG1-input";
        element.style.width = "90%";
        element.style.direction = "ltr";
        element.type = "text";
        element.style.margin = "2px";
        element.style.fontSize = "24px";
        element.style.fontWeight = "bold";
        element.style.border = "3px solid black";
        element.style.borderRadius = "6px";
        element.style.padding = "1px";
        element.style.outline = "none";

        if (DIALOG1.par_input_OBJ.OBJ_EXIST == false) {
            element.value = "";
        }
        if (DIALOG1.par_input_OBJ.OBJ_EXIST == true) {
            element.value = DIALOG1.par_input_OBJ.GetStr();
        }

        var delay_in_miliseconds = 10;
        UTL.perform_focus_and_select_of_input_element_after_delay(element, delay_in_miliseconds);

        return element;
    }

    private static create_panel_element(): HTMLDivElement {
        var buttonsContainer = document.createElement("div");
        buttonsContainer.style.marginTop = "15px";
        buttonsContainer.style.display = "flex";
        buttonsContainer.style.justifyContent = "space-around";
        buttonsContainer.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_panel_backgroundColor();
        buttonsContainer.style.marginBottom = "7px";
        return buttonsContainer;
    }

    private static create_ok_button_element(): HTMLButtonElement {
        return DIALOG_AUX_FUNCTIONS.create_ok_button_element();
    }

    private static create_cancel_button_element(): HTMLButtonElement {
        return DIALOG_AUX_FUNCTIONS.create_cancel_button_element();
    }

    private static create_erase_button_element(): HTMLButtonElement {
        return DIALOG_AUX_FUNCTIONS.create_erase_button_element();
    }

    private static overlay_mousedown(event: MouseEvent): void {
        var target_element = event.target;
        if (target_element == DIALOG1.caption_element) {
            var popup_element_bounding_rect = DIALOG1.popup_element.getBoundingClientRect();
            DIALOG1.MD_FLAG = true;
            DIALOG1.Vamod_MouseX = event.clientX;
            DIALOG1.Vamod_MouseY = event.clientY;
            DIALOG1.Vamod_ModalWindowLeftX = popup_element_bounding_rect.left;
            DIALOG1.Vamod_ModalWindowTopY = popup_element_bounding_rect.top;
        }
        if (target_element == DIALOG1.defo_button_element) {
            DIALOG1.defo_button_is_clicked = true;
        }
    }

    private static overlay_mousemove(event: MouseEvent): void {
        if (DIALOG1.MD_FLAG == true) {
            var delta_x = event.clientX - DIALOG1.Vamod_MouseX;
            var delta_y = event.clientY - DIALOG1.Vamod_MouseY;
            DIALOG1.popup_element.style.left = (DIALOG1.Vamod_ModalWindowLeftX + delta_x) + "px";
            DIALOG1.popup_element.style.top = (DIALOG1.Vamod_ModalWindowTopY + delta_y) + "px";
        }
    }

    private static overlay_mouseup(event: MouseEvent): void {
        var freezed_defo_button_is_clicked = DIALOG1.defo_button_is_clicked;
        DIALOG1.MD_FLAG = false;
        DIALOG1.defo_button_is_clicked = false;
        if (freezed_defo_button_is_clicked == false) {
            DIALOG1.input_element.focus();
        }
    }

    private static perform_pseudo_focused_button(): void {
        if (DIALOG1.var_current_pseudo_focused_btn == DIALOG1.BID.OK) {
            DIALOG1.perform_ok();
        }
        if (DIALOG1.var_current_pseudo_focused_btn == DIALOG1.BID.CANCEL) {
            DIALOG1.perform_cancel();
        }
        if (DIALOG1.var_current_pseudo_focused_btn == DIALOG1.BID.ERASE) {
            DIALOG1.perform_erase();
        }
    }

    private static overlay_keydown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            DIALOG1.perform_pseudo_focused_button();
        }
        if (event.key === 'Escape') {
            DIALOG1.perform_cancel();
        }
        if (event.key === 'Tab') {
            event.preventDefault();
            if (event.shiftKey == false) DIALOG1.respond_tab();
            if (event.shiftKey == true) DIALOG1.respond_shift_tab();
        }
    }

    private static perform_ok(): void {
        const change_flag = true;
        const value_exist = true;
        const value_content = DIALOG1.input_element.value;
        DIALOG1.call_callback(change_flag, value_exist, value_content);
    }

    private static perform_defo(): void {
        UTL.show_which_element_has_focus();
    }

    private static perform_cancel(): void {
        const change_flag = false;
        const value_exist = false;
        const value_content = "";
        DIALOG1.call_callback(change_flag, value_exist, value_content);
    }

    private static perform_erase(): void {
        const change_flag = true;
        const value_exist = false;
        const value_content = "";
        DIALOG1.call_callback(change_flag, value_exist, value_content);
    }

    private static create_new_br_element(): HTMLBRElement {
        return document.createElement('br');
    }

    private static paint_colors_in_select_elements(element: HTMLElement, bval: boolean): void {
        if (bval == false) {
            element.style.backgroundColor = "white";
            element.style.color = "black";
        }
        if (bval == true) {
            element.style.backgroundColor = "blue";
            element.style.color = "white";
        }
    }

    private static create_result_OBJ(p_value_exist: boolean, p_value_conent: string): oBase {
        // TypeScript שים לב בתאריך 12.4.2026 הוספנו טלאי כאן בגלל באג שכנראה נוצר במעבר ל
        // TypeScript שים לב בתאריך 12.4.2026 הוספנו טלאי כאן בגלל באג שכנראה נוצר במעבר ל
        // TypeScript שים לב בתאריך 12.4.2026 הוספנו טלאי כאן בגלל באג שכנראה נוצר במעבר ל 
        let value_content_as_int = 0; // לא ברור לי מה צריך להציב כאן
        if (p_value_conent != "") {
            value_content_as_int = parseInt(p_value_conent, 10);
        }
        if (DIALOG1.par_input_OBJ instanceof oInt16) return new oInt16(p_value_exist, value_content_as_int);
        if (DIALOG1.par_input_OBJ instanceof oInt32) return new oInt32(p_value_exist, value_content_as_int);
        if (DIALOG1.par_input_OBJ instanceof oInt64) return new oInt64(p_value_exist, value_content_as_int);
        alert("DIALOG1.error unknwon object");
    }

    private static call_callback(p_change_flag: boolean, p_value_exist: boolean, p_value_conent: string): void {
        debugger;
        if (DIALOG1.par_callback_function != null) {
            document.body.removeChild(DIALOG1.overlay_element);
            var delay_in_milliseconds = 0;
            var OBJ = DIALOG1.create_result_OBJ(p_value_exist, p_value_conent);

            if (true) {
                setTimeout(DIALOG1.par_callback_function, delay_in_milliseconds, p_change_flag, OBJ);
            }
            if (false) {
                DIALOG1.par_callback_function(p_change_flag, OBJ);
            }
            if (false) {
                setTimeout(() => {
                    DIALOG1.par_callback_function(p_change_flag, OBJ);
                }, 0);
            }
        } else {
            alert("DIALOG1_callback_function != null");
        }
    }

    public static create_dialog(p_callback_function: Function, p_input_OBJ: oInt16 | oInt32 | oInt64, p_wisper: Whisper): void {
        DIALOG1.par_callback_function = p_callback_function;
        DIALOG1.par_input_OBJ = p_input_OBJ;
        DIALOG1.par_wisper = p_wisper;

        DIALOG1.overlay_element = DIALOG1.create_overlay_element();
        DIALOG1.popup_element = DIALOG1.create_popup_element();
        DIALOG1.caption_element = DIALOG1.create_caption_element();
        DIALOG1.close_button_element = DIALOG1.create_close_button();
        DIALOG1.defo_button_element = DIALOG1.create_defo_button();
        DIALOG1.select_false_element = DIALOG1.create_select_false_element();
        DIALOG1.select_true_element = DIALOG1.create_select_true_element();
        DIALOG1.input_element = DIALOG1.create_input_element();
        DIALOG1.panel_element = DIALOG1.create_panel_element();
        DIALOG1.ok_button_element = DIALOG1.create_ok_button_element();
        DIALOG1.cancel_button_element = DIALOG1.create_cancel_button_element();
        DIALOG1.erase_button_element = DIALOG1.create_erase_button_element();

        DIALOG1.overlay_element.appendChild(DIALOG1.popup_element);
        DIALOG1.caption_element.appendChild(DIALOG1.close_button_element);
        DIALOG1.caption_element.appendChild(DIALOG1.defo_button_element);
        DIALOG1.popup_element.appendChild(DIALOG1.caption_element);
        DIALOG1.popup_element.appendChild(DIALOG1.create_new_br_element());
        DIALOG1.popup_element.appendChild(DIALOG1.create_new_br_element());
        DIALOG1.popup_element.appendChild(DIALOG1.input_element);
        DIALOG1.popup_element.appendChild(DIALOG1.panel_element);
        DIALOG1.panel_element.appendChild(DIALOG1.ok_button_element);
        DIALOG1.panel_element.appendChild(DIALOG1.cancel_button_element);
        DIALOG1.panel_element.appendChild(DIALOG1.erase_button_element);

        DIALOG1.overlay_element.addEventListener("mousedown", DIALOG1.overlay_mousedown);
        DIALOG1.overlay_element.addEventListener("mousemove", DIALOG1.overlay_mousemove);
        DIALOG1.overlay_element.addEventListener("mouseup", DIALOG1.overlay_mouseup);
        DIALOG1.overlay_element.addEventListener("keydown", DIALOG1.overlay_keydown);
        DIALOG1.defo_button_element.addEventListener("click", DIALOG1.perform_defo);
        DIALOG1.ok_button_element.addEventListener("click", DIALOG1.perform_ok);
        DIALOG1.cancel_button_element.addEventListener("click", DIALOG1.perform_cancel);
        DIALOG1.erase_button_element.addEventListener("click", DIALOG1.perform_erase);
        DIALOG1.close_button_element.addEventListener("click", DIALOG1.perform_cancel);

        document.body.appendChild(DIALOG1.overlay_element);
        UTL.center_popup_element_inside_overlay_element(DIALOG1.popup_element, DIALOG1.overlay_element);
        DIALOG1.var_current_pseudo_focused_btn = DIALOG1.BID.OK;
        DIALOG1.refresh_pseudo_focus_for_all_buttons();
        DIALOG1.input_element.focus();
    }
}